var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "list", staticClass: "list" }, [
    _c(
      "div",
      { staticClass: "wrapper" },
      _vm._l(_vm.list, function (house, index) {
        return _c("house-item", {
          key: index,
          attrs: { house: house, type: _vm.type },
          on: { handleHosue: _vm.handleHosue },
        })
      }),
      1
    ),
    _vm._v(" "),
    _vm.loadMore.scrollStatu != "hide"
      ? _c("div", { ref: "scrollWrapperTip", staticClass: "loadmore-tip" }, [
          _c("span", { staticClass: "text-loadmore" }, [
            _vm._v(
              _vm._s(_vm._f("scrollTextFilter")(_vm.loadMore.scrollStatu))
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.list.length == 0
      ? _c("div", { staticClass: "wrapper-null" }, [_vm._v("暂无拥有房源")])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }